import { FlowType } from '@ace-clublabs/common-membership-api-types';
import { ClubCode } from './enum';

export enum PartnerIntegration {
  PARKING_SPOT = 'THEPARKINGSPOT',
  EXPERIAN = 'EXPERIAN',
  HERTZ = 'HERTZ',
}

export interface IPartnerIntegration {
  name: PartnerIntegration;
  hasExistingAccount?: boolean;
  isSelectedByDefault?: boolean;
}

export interface IPartnerIntegrationEnv extends Omit<IPartnerIntegration, 'isSelectedByDefault'> {
  isEnabled: boolean;
  blacklistedClubCodes: ClubCode[];
  blacklistedFlowTypes: FlowType[];
  clubsNotSelectedByDefault: ClubCode[];
}
